import Nav  from "./components/nav.js";
import Slider from "./components/slider.js";
import Animate from "./components/animate.js";
import { Icons } from "./components/icons.js";
import Footer from "./components/footer.js";
import Projects from "./components/projects.js";
import Contact from "./components/contact.js";
import AboutSidebar from "./pages/about.js";
import { ProjectsTabs, ProjectGallery, ProjectsFilter } from "./pages/projects.js";
import BlogFilter from "./pages/blogs.js";
import HomeBlogSlider from "./components/blog.js";
import Products from "./components/product.js";
import CookieConsent from "./components/cookies.js";
import ServiceModal from "./components/serviceModal.js";
import ProductDetail from "./pages/product.js";

class Main {
  constructor() {
    this.init();
  }
  init() {
    new Slider();
    new Nav();
    new Footer();
    new Animate();
    new Icons();
    new Projects();
    new Products();
    new Contact();
    new AboutSidebar();
    new ProjectGallery();
    new ProjectsTabs();
    new ProjectsFilter();
    new BlogFilter();
    new HomeBlogSlider();
    new CookieConsent();
    new ServiceModal();
    new ProductDetail();
  }
}

export default Main;

document.addEventListener("DOMContentLoaded", () => {
 new Main();
});
